// removed by extract-text-webpack-plugin
module.exports = {"dark":"style-local__dark___3Wv_Q","transparent":"style-local__transparent___3WtjT","highlight-letter":"style-local__highlight-letter___3VH4K","highlight-letter-background":"style-local__highlight-letter-background___B8Y_y","logo-smallfont":"style-local__logo-smallfont___1o4hT","logo-bigfont":"style-local__logo-bigfont___2clCX"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/AppBar/style.local.scss
// module id = 252
// module chunks = 0